import { schedulingGet, fetchAllCursorPages } from "./client";

export function listAvailableSlots({
  organizationRef,
  serviceCategoryId,
  startsAt,
  endsAt,
  practitionerRef,
  excludeAppointmentId,
  cursor,
  limit = 500,
  signal,
  consistency,
}) {
  return schedulingGet("availableSlots", {
    organizationRef,
    serviceCategoryId,
    startsAt,
    endsAt,
    practitionerRef,
    excludeAppointmentId,
    cursor,
    limit,
  }, { signal, consistency });
}

export function listNoPreferenceSlots({
  organizationRef,
  serviceCategoryId,
  startsAt,
  endsAt,
  cursor,
  limit = 500,
  signal,
  consistency,
}) {
  return schedulingGet("availableSlots/noPreference", {
    organizationRef,
    serviceCategoryId,
    startsAt,
    endsAt,
    cursor,
    limit,
  }, { signal, consistency });
}

export async function listAllAvailableSlots(params, noPreference = false) {
  const fetchPage = noPreference ? listNoPreferenceSlots : listAvailableSlots;
  return fetchAllCursorPages({ itemsKey: "slots", signal: params.signal, fetchPage: async cursor => {
    const response = await fetchPage({ ...params, cursor });
    if (params.excludeAppointmentId && (response?.reschedule?.appointmentId !== params.excludeAppointmentId || response?.reschedule?.practitionerChange !== true)) {
      throw new Error("Could not load available times. Please try again.");
    }
    return response;
  } });
}
export async function listAvailableDates(params, noPreference, signal, consistency) {
  const response = await schedulingGet(noPreference ? "availableSlots/noPreference" : "availableSlots", {
    ...params, practitionerRefs: params.practitionerRefs?.join(","), limit: 32,
  }, { signal, consistency });
  if (response?.datesSummary !== true || response.nextCursor || !Array.isArray(response.slots)) throw new Error("Could not load available dates. Please try again.");
  if (params.excludeAppointmentId && response?.reschedule?.appointmentId !== params.excludeAppointmentId) throw new Error("Could not load available times. Please try again.");
  return response.slots;
}
